<div class="rounded-3xl border border-gray-200/80 bg-white/40 p-4 shadow-sm dark:border-[#191e3a] dark:bg-dark/10 md:p-6">
  <div class="mb-4 flex items-center justify-between">
    <h3 class="text-sm font-semibold text-gray-800 dark:text-white">Version history</h3>
    <span class="text-xs text-gray-500">page {{ page }} / {{ totalPages }}</span>
  </div>

  <p *ngIf="loading" class="text-sm text-gray-500">Loading versions…</p>
  <p *ngIf="!loading && versions.length === 0" class="text-sm text-gray-500">No versions yet for this scope.</p>

  <table *ngIf="!loading && versions.length > 0" class="w-full text-left text-sm">
    <thead class="text-xs text-gray-500 dark:text-gray-400">
      <tr>
        <th class="py-2 pr-3">Version</th>
        <th class="py-2 pr-3">Status</th>
        <th class="py-2 pr-3">Created</th>
        <th class="py-2 pr-3 text-right">Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let v of versions" class="border-t border-gray-100 dark:border-[#191e3a]">
        <td class="py-2 pr-3 font-medium text-gray-800 dark:text-gray-200">
          v{{ v.version_seq }}
          <span *ngIf="v.restore_tag" class="ml-1 text-xs text-gray-400" [title]="v.restore_tag">↻</span>
        </td>
        <td class="py-2 pr-3">
          <span [ngSwitch]="chip(v)" class="rounded-full px-2.5 py-0.5 text-xs font-semibold">
            <span *ngSwitchCase="'ACTIVE'" class="bg-emerald-100 text-emerald-800 dark:bg-emerald-950/40 dark:text-emerald-200">● Active</span>
            <span *ngSwitchCase="'DRAFT'" class="bg-amber-100 text-amber-800 dark:bg-amber-950/40 dark:text-amber-200">Draft</span>
            <span *ngSwitchDefault class="bg-gray-100 text-gray-600 dark:bg-white/10 dark:text-gray-300">Superseded</span>
          </span>
        </td>
        <td class="py-2 pr-3 text-xs text-gray-500">{{ v.created_at | date: 'short' }}</td>
        <td class="py-2 pr-3">
          <div class="inline-flex items-center justify-end gap-1">
            <button
              type="button"
              class="inline-flex h-9 w-9 items-center justify-center rounded-lg text-primary hover:bg-primary/10"
              title="View"
              aria-label="View"
              (click)="view.emit(v)"
            >
              <icon-eye class="h-4 w-4" />
            </button>
            @if (chip(v) === 'DRAFT') {
            <button
              type="button"
              class="inline-flex h-9 w-9 items-center justify-center rounded-lg text-blue-500 hover:bg-blue-500/10 disabled:opacity-50"
              title="Publish"
              aria-label="Publish"
              [disabled]="busyId === v.id"
              (click)="publish.emit(v)"
            >
              <icon-send class="h-4 w-4" />
            </button>
            }
            @if (chip(v) === 'SUPERSEDED') {
            <button
              type="button"
              class="inline-flex h-9 w-9 items-center justify-center rounded-lg text-blue-500 hover:bg-blue-500/10 disabled:opacity-50"
              title="Restore"
              aria-label="Restore"
              [disabled]="busyId === v.id"
              (click)="restore.emit(v)"
            >
              <icon-restore class="h-4 w-4" />
            </button>
            }
          </div>
        </td>
      </tr>
    </tbody>
  </table>

  <div *ngIf="!loading && totalPages > 1" class="mt-4 flex items-center justify-end gap-2 text-xs">
    <button type="button" class="rounded-md border border-gray-300 px-2.5 py-1 disabled:opacity-50 dark:border-[#191e3a]" [disabled]="page <= 1" (click)="prev()">Prev</button>
    <button type="button" class="rounded-md border border-gray-300 px-2.5 py-1 disabled:opacity-50 dark:border-[#191e3a]" [disabled]="page >= totalPages" (click)="next()">Next</button>
  </div>
</div>
